import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CopyIcon from "../../../../assets/images/Copy.svg";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { showNotificationToast, toastify } from "../../../../helpers/toast/toastify";
import Modal from "react-bootstrap/Modal";
import CopyLogo from "../../../../assets/images/onboardingImages/logo_black.svg";
import { fetchUser } from "../../../../helpers/helper";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { useSelector, useDispatch } from "react-redux";
import { storeUser } from "../../../../redux/users/usersSlice";
import SettingGif from "../../../../assets/images/onboardingImages/setting.gif";
import "./Done.css";
import BubbleSvgButton from "../../../sharedPages/CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { globalAllLeaderCommunities, globalCurrentPageTitle } from "../../../../store/globalstore";
import { useAtom } from "jotai";
import { resetOnBoardingStartContext } from "../../../../redux/users/usersSlice";

const Done = () => {
  const { state:locationState } = useLocation();
  const navigate = useNavigate();
  const [leaderCommunityName, setLeaderCommunityName] = useState("");
  const [currentPageTitle, setCurrentPageTitle] = useAtom(
    globalCurrentPageTitle
  )
  const { user } = useSelector((state) => state.user);
  const verifiedmyTrade = !!(user?.verifiedmyTrade?.payment || user?.verifiedmyTrade?.subscription?.subscriptionId);
  const [allLeaderCommunities, setAllLeaderCommunities] = useAtom(
      globalAllLeaderCommunities
    );
  const dispatch = useDispatch();
  const state=useSelector(state=>state);
  const [show, setShow] = useState(true);
  const api = useApi();
  const isOnBoardingComplete =
  user?.onboarding?.isCommunityCreated &&
  user?.onboarding?.connect &&
  user?.onboarding?.payment &&
  user?.onboarding?.subscribed &&
  user?.onboarding?.isVerified;
  useEffect(()=>{
    fetchUser(api, dispatch, storeUser);
  },[]);

  useEffect(() => {
    setLeaderCommunityName(user?.leaderCommunity?.name);
  }, [user]);
  useEffect(()=>{
    if(!locationState&&!(locationState?.from==="onboarding")){
      navigate("/leader/dashboard", { replace: true });
      return;
     }
  },[])
  const Finish = async () => {
    await fetchUser(api, dispatch, storeUser);  
    if(user?.tradeName&&allLeaderCommunities.length===1&&verifiedmyTrade){
      navigate("/leader/onboardingCopyTradeService",{replace: true, state: { from: "onboarding" }});
      return;
    }
    showNotificationToast("Copy trading is active!", `Your copy trading service is live and ready to share 🚀\n\nYour community can now copy your trades in just a few clicks. Once they sign up, connect, and subscribe—they’re trading what you trade.\n\nShare your landing page to start growing: ${document.location.origin.replace(
                        document.location.pathname,
                        ""
                      )}/community/${leaderCommunityName?.split(" ").join("")}\n\nTip:\n> Auto-share results to Telegram, Discord, or X. \n> Verify your performance for full transparency`);
    dispatch(resetOnBoardingStartContext());
    setCurrentPageTitle("Dashboard");
    navigate("/leader/dashboard", { replace: true });
  };
 
  // if(isOnBoardingComplete){
  //   navigate("/leader/dashboard", { replace: true });
  //   return;
  //  }
  return (
    <div className="onboarding-modal-wrapper">
      <Modal
        animation={false}
        backdropClassName="onboarding-custom-backdrop"
        centered
        dialogClassName="custom-onboarding-modal cmSide doneCM"
        show={show}
      >
        <Modal.Body className="figma-drop-shadow">
          <div className="onboardingContentBox top73px">
            {/* <h2 className="title">
              <span>Done!</span>
            </h2>
            <p className="desc bottom29px">
              You're good to go! Here's the sign up page <br /> for your copy
              tradeing service.
            </p>
            <div className="formBox">
              <div className="mb-20px">
                <InputGroup className="onboardingInput custom">
                  <Form.Control
                    aria-describedby="copuCommunity"
                    aria-label="Username"
                    disabled
                    placeholder="Username"
                    value={`${document.location.origin.replace(
                      document.location.pathname,
                      ""
                    )}/community/${leaderCommunityName.split(" ").join("")}`}
                  />
                  <InputGroup.Text id="copuCommunity">
                    <button type="button">
                      <img
                        src={CopyIcon}
                        alt="Copy icon"
                        onClick={() => {
                          // Construct the community link using template literals
                          const communityLink = `${document.location.origin.replace(
                            document.location.pathname,
                            ""
                          )}/community/${leaderCommunityName
                            .split(" ")
                            .join("")}`;

                          // Attempt to copy the link to the clipboard
                          navigator.clipboard
                            .writeText(communityLink)
                            .then(() => {
                              // Success: Show a toast notification
                              toastify(
                                "Community link copied to clipboard!",
                                "success"
                              );
                            })
                            .catch((error) => {
                              // Error: Handle clipboard write failure and show a toast notification
                              console.error("Clipboard write error:", error);
                              toastify(
                                "Failed to copy community link to clipboard.",
                                "error"
                              );
                            });
                        }}
                      />
                    </button>
                  </InputGroup.Text>
                </InputGroup>
              </div>
              <div className="listBox">
                <p className="title">Remember you can:</p>
                <p className="listItem">- Share result automatically</p>
                <p className="listItem">- Get your service as an app</p>
              </div>
              <button
                className="NextBtn"
                onClick={() => Finish()}
                type="button"
              >
                Finish
              </button>
            </div> */}

            <div className="onboardingContentBox top73px">
              <img className="comletedGif" src={SettingGif} alt="Setting Gif" />
              <p className="completedTitle pt14px">Yay! Setup is complete!</p>
              <p className="completedDesc">Here's your unique sign up page.</p>

              <div className="formBox copylinkFormBox">
                <div className="mb-20px">
                  <InputGroup className="onboardingInput custom">
                    <Form.Control
                      aria-describedby="copuCommunity"
                      aria-label="Username"
                      disabled
                      placeholder="Username"
                      value={`${document.location.origin.replace(
                        document.location.pathname,
                        ""
                      )}/community/${leaderCommunityName?.split(" ").join("")}`}
                    />
                    <InputGroup.Text id="copuCommunity">
                      <button type="button">
                        <img
                          src={CopyIcon}
                          alt="Copy icon"
                          onClick={() => {
                            // Construct the community link using template literals
                            const communityLink = `${document.location.origin.replace(
                              document.location.pathname,
                              ""
                            )}/community/${leaderCommunityName
                              .split(" ")
                              .join("")}`;

                            // Attempt to copy the link to the clipboard
                            navigator.clipboard
                              .writeText(communityLink)
                              .then(() => {
                                // Success: Show a toast notification
                                toastify(
                                  "Community link copied to clipboard!",
                                  "success"
                                );
                              })
                              .catch((error) => {
                                // Error: Handle clipboard write failure and show a toast notification
                                console.error("Clipboard write error:", error);
                                toastify(
                                  "Failed to copy community link to clipboard.",
                                  "error"
                                );
                              });
                          }}
                        />
                      </button>
                    </InputGroup.Text>
                  </InputGroup>
                </div>
              </div>

              <BubbleSvgButton
                className="NextBtnInv"
                onClick={Finish}
                text={"Ok, let's go!"}
                type="button"
                variant="black"
                containerStyling={{
                  justifyContent: "center",
                }}
                mainDivStyle={{
                  width: "275px",
                  height: "55px",
                }}
              />
            </div>
          </div>

          <div className="paginationDots">
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className="dot"></button>
            <button className={`dot`}></button>
            <button className={`dot active`}></button>
          </div>
          <div className="copyrightBox">
            <p className="">
              Powered by{" "}
              <span className="spanMain">
                <img src={CopyLogo} alt="" />
              </span>
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Done;
